import styled from "styled-components";
import React from 'react';
import { BRAND_TYPE } from "constants/brands";
import { mapBrandTypeBackground, mapBrandTypeColor, mapBrandTypeBorder, mapBrandTypeLabel } from "utils/brand";

const BrandTypeChip = styled.span<{ type: string; margin: string }>`
  background-color: ${({ type }) => mapBrandTypeBackground(type)};
  color: ${({ type }) => mapBrandTypeColor(type)};
  border: ${({ type }) => `1px solid ${mapBrandTypeBorder(type)}`};
  min-width: 110px;
  height: auto;
  text-align: center;
  border-radius: 7px 0px 7px 0px;
  display: inline-block;
  font-size: 14px;
  margin: ${({ margin }) => margin ? margin : '0px'};
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px 12px;

  @media print {
    padding-top: 4px
  }
`;

interface Props {
  type?: string;
  margin?: string;
}

const BrandType = ({ type = BRAND_TYPE.BRAND, margin = '0px 0px' }: Props) => {
  return (
    <BrandTypeChip margin={margin} type={type}>{mapBrandTypeLabel(type)}</BrandTypeChip>
  );
}

export default BrandType;